function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@ori-ui/components';
import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useState } from 'react';
import { useConfiguration } from '../../contexts';
import { SocialMediaPlatforms } from '../../models';
import { getSocialMedia } from './getSocialMedia';
var SocialNetworkRoot = styled('div')(function(param) {
    var theme = param.theme;
    return {
        margin: theme.spacing(1, 0),
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
});
var ButtonStyled = styled(Button)(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0),
        width: '100%',
        height: '46px',
        maxWidth: '330px',
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center'
    };
});
var SocialNetworkWrapper = styled('div')(function() {
    return {
        textAlign: 'center'
    };
});
var ExternalProviderStyled = styled('div')(function(param) {
    var theme = param.theme;
    return {
        margin: theme.spacing(0, 0, 4),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1)
    };
});
export var SocialNetworks = function() {
    var _useTestId = useTestId(), getTestIdProps = _useTestId.getTestIdProps, getTestId = _useTestId.getTestId;
    var _useConfiguration = useConfiguration(), externalProviders = _useConfiguration.externalProviders, identityUrl = _useConfiguration.identityUrl, returnUrl = _useConfiguration.returnUrl;
    var _useState = _sliced_to_array(useState(false), 2), disabledProviders = _useState[0], setDisabledProviders = _useState[1];
    var externalProviderItems = externalProviders.map(function(item) {
        var itemProviderName = item.displayName.toLowerCase();
        var handleProviderRedirect = function() {
            setDisabledProviders(true);
            var paramsObj = {
                scheme: item.authenticationScheme,
                returnUrl: returnUrl
            };
            var searchParams = new URLSearchParams(paramsObj).toString();
            var externalUrl = new URL("External/Challenge?".concat(searchParams), identityUrl);
            window.location.href = externalUrl.href;
        };
        if (itemProviderName === SocialMediaPlatforms.ActiveDirectory) {
            return null;
        }
        return /*#__PURE__*/ _jsx(SocialNetworkRoot, {
            "data-testid": getTestId("social-network-".concat(itemProviderName)),
            children: /*#__PURE__*/ _jsx(ButtonStyled, {
                variant: "outlined",
                disabled: disabledProviders,
                onClick: handleProviderRedirect,
                children: getSocialMedia(itemProviderName)
            })
        }, itemProviderName);
    });
    return /*#__PURE__*/ _jsx(SocialNetworkWrapper, _object_spread_props(_object_spread({}, getTestIdProps('social-network')), {
        children: /*#__PURE__*/ _jsx(ExternalProviderStyled, {
            children: externalProviderItems
        })
    }));
};
